import EventBus from "@/utils/EventBus";
import Events from "@/utils/Events";
import ServerEvents from "@/server/ServerEvents";
import EntityPrintoutQuery from "@/server/com/silkplm/engine/model/EntityPrintoutQuery";

class _ReportsManager{
    constructor() {
    }

    async executeReport(reportClazz, parameters = null){ //TODO POZBIERAĆ PARAMETRY dla 2 param
        let task = await Rpc.Reports.execute(reportClazz, parameters);
    }
}

const ReportsManager = new _ReportsManager();
window['ReportsManager'] = ReportsManager;

export default ReportsManager;
